<template>
  <div>
    <main class="audioPlayer" v-if="musicPlaylist">
      <!--Кнопка меню-->
      <!--<a class="nav-icon" v-on:click="isPlaylistActive=!isPlaylistActive" :class="{'isActive': isPlaylistActive}" title="Music List">
        <span></span>
        <span></span>
        <span></span>
      </a>-->

      <!--Плейлист-->
      <div class="audioPlayerList" :class="{'isActive': isPlaylistActive}">
        <div class="item" v-for="(item,index) in musicPlaylist" :key="item.id" v-bind:class="{ 'isActive':isCurrentSong(index) }" v-on:click="changeSong(index),isPlaylistActive=!isPlaylistActive">
          <p class="title">{{ item.title }}</p>
          <p class="artist">{{ item.artist }}</p>
        </div>

        <!-- <p class="debugToggle" v-on:click="toggleDebug()">debug: {{ debug }}</p>-->
      </div>


      <div class="audioPlayerUI" :class="{'isDisabled': isPlaylistActive}">

        <!--Подробности о песне - исполнитель / название-->
        <div class="albumDetails" v-if="musicPlaylist[currentSong]">
          <transition name="slide-fade" mode="out-in">
            <p class="title" :key="currentSong">{{ musicPlaylist[currentSong].artist }}
              <template v-if="musicPlaylist[currentSong].title"><br>{{ musicPlaylist[currentSong].title }}</template>
            </p>
          </transition>
          <!--<transition name="slide-fade" mode="out-in">
            <p class="artist" :key="currentSong">{{ musicPlaylist[currentSong].artist }}</p>
          </transition>-->
        </div>

        <!--Кнопки управления-->
        <div class="playerButtons">
          <a class="button" :class="{'isDisabled':(currentSong==0)}" v-on:click="prevSong()" title="Предыдущая"><i class="c_button previus"></i></a>
          <a class="button play" v-on:click="playAudio()" title="Играть / Пауза">
            <transition name="slide-fade" mode="out-in">
              <i class="c_button" :class="[currentlyStopped ? 'b_stop' : (currentlyPlaying ? 'b_pause' : 'b_play')]" :key="1"></i>
            </transition>
          </a>
          <a class="button" :class="{'isDisabled':(currentSong==musicPlaylist.length-1)}" v-on:click="nextSong()" title="Следующая"><i class="c_button next"></i></a>
        </div>

        <!--Прогресс - Тайминг-->
        <div class="currentTimeContainer" style="text-align:center">
          <span class="currentTime">{{ currentTime | fancyTimeFormat }}</span>
          <span class="totalTime"> {{ trackDuration | fancyTimeFormat }}</span>
          <!--<span style="color:black">({{ currentSong+1 }}/{{ musicPlaylist.length }})</span>-->
        </div>

        <div class="currentProgressBar">
          <div class="currentProgress" :style="{ width: currentProgressBar + '%' }"></div>
        </div>
      </div>

      <ol class="bottom_playlist">
        <li class="item" v-for="(item,index) in musicPlaylist" :key="item.id" @click="changeSong(index)" v-bind:class="{ 'isActive':isCurrentSong(index) }">
          {{ item.artist }}
          <template v-if="item.title"> - {{ item.title }}</template>
        </li>
      </ol>
    </main>
  </div>
</template>

<script>
import Http from '../classes/http'

export default {
  name: "player",
  data() {
    return {
      http: new Http(this),
      audio: "",
      imgLoaded: false,
      currentlyPlaying: false,
      currentlyStopped: false,
      currentTime: 0,
      checkingCurrentPositionInTrack: "",
      trackDuration: 0,
      currentProgressBar: 0,
      isPlaylistActive: false,
      currentSong: 0,
      debug: false,
      fullPlaylist: [],
      musicPlaylist: [],
      audioFile: ""
    }
  },

  async mounted() {
    this.fullPlaylist = await this.getPlaylist();
    this.musicPlaylist = this.fullPlaylist.songs;
    this.changeSong();
    this.audio.loop = false;
    this.$parent.$on('destroy app', this.stopAudio);
  },
  filters: {
    fancyTimeFormat: function (s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    }
  },
  methods: {
    getPlaylist() {
      return this.http.post('onGetPlaylist').then(res => res.data);
    },

    togglePlaylist: function () {
      this.isPlaylistActive = !this.isPlaylistActive;
    },
    nextSong: function () {
      if (this.currentSong < this.musicPlaylist.length - 1)
        this.changeSong(this.currentSong + 1);
    },
    prevSong: function () {
      if (this.currentSong > 0) this.changeSong(this.currentSong - 1);
    },
    changeSong: function (index) {
      var wasPlaying = this.currentlyPlaying;
      this.imageLoaded = false;
      if (index !== undefined) {
        this.stopAudio();
        this.currentSong = index;
      }
      let item = this.musicPlaylist[this.currentSong];
      let folder = this.fullPlaylist.site_url + '/' + this.fullPlaylist.folder;
      this.audioFile = folder + '/' + item.file;
      this.audio = new Audio(this.audioFile);
      var localThis = this;
      this.audio.addEventListener("loadedmetadata", function () {
        localThis.trackDuration = Math.round(this.duration);
      });
      this.audio.addEventListener("ended", this.handleEnded);
      if (wasPlaying) {
        this.playAudio();
      }
    },
    isCurrentSong: function (index) {
      if (this.currentSong == index) {
        return true;
      }
      return false;
    },
    getCurrentSong: function (currentSong) {
      return this.musicPlaylist[currentSong].url;
    },
    playAudio: function () {
      if (
          this.currentlyStopped == true &&
          this.currentSong + 1 == this.musicPlaylist.length
      ) {
        this.currentSong = 0;
        this.changeSong();
      }
      if (!this.currentlyPlaying) {
        this.getCurrentTimeEverySecond(true);
        this.currentlyPlaying = true;
        this.audio.play();
      } else {
        this.stopAudio();
      }
      this.currentlyStopped = false;
    },
    stopAudio: function () {
      this.audio.pause();
      this.currentlyPlaying = false;
      this.pausedMusic();
    },
    handleEnded: function () {
      if (this.currentSong + 1 == this.musicPlaylist.length) {
        this.stopAudio();
        this.currentlyPlaying = false;
        this.currentlyStopped = true;
      } else {
        this.currentlyPlaying = false;
        this.currentSong++;
        this.changeSong();
        this.playAudio();
      }
    },
    onImageLoaded: function () {
      this.imgLoaded = true;
    },
    getCurrentTimeEverySecond: function (startStop) {
      var localThis = this;
      this.checkingCurrentPositionInTrack = setTimeout(
          function () {
            localThis.currentTime = localThis.audio.currentTime;
            localThis.currentProgressBar =
                localThis.audio.currentTime / localThis.trackDuration * 100;
            localThis.getCurrentTimeEverySecond(true);
          }.bind(this),
          1000
      );
    },
    pausedMusic: function () {
      clearTimeout(this.checkingCurrentPositionInTrack);
    },
  },
  watch: {
    currentTime: function () {
      this.currentTime = Math.round(this.currentTime);
    }
  },
  beforeDestroy: function () {
    this.audio.removeEventListener("ended", this.handleEnded);
    this.audio.removeEventListener("loadedmetadata", this.handleEnded);

    clearTimeout(this.checkingCurrentPositionInTrack);
  }
}
</script>

<style scoped lang="scss">

$primary_color: #f1f3f4;
$player_width: 20rem;
$player_padding: 1.5rem;
$player_border_radius: 0rem;

$button_size: 2rem;

$anim_duration: 0.5s;

* {
  box-sizing: border-box;
}

.animated {
  animation-duration: $anim_duration;
}

.audioPlayer {
  position: relative;
  background-color: #eceff1;

  //min-height: 25rem;
  //width: $player_width;
  width: 100%;

  overflow: hidden;

  padding: $player_padding $player_padding 0 $player_padding;
  margin: 0 auto;

  border-radius: $player_border_radius;
  //box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);

  user-select: none;

  .nav-icon {
    width: 15px;
    height: 12px;

    position: absolute;
    top: ($player_padding)-($player_padding/4);
    left: $player_padding;

    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    cursor: pointer;

    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      background: $primary_color;
      border-radius: 6px;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: 0.5s ease-in-out;
    }

    span:nth-child(1) {
      top: 0px;
    }

    span:nth-child(2) {
      top: 5px;
    }

    span:nth-child(3) {
      top: 10px;
    }

    &.isActive span:nth-child(1) {
      top: 5px;
      transform: rotate(135deg);
    }

    &.isActive span:nth-child(2) {
      opacity: 0;
      left: -60px;
    }

    &.isActive span:nth-child(3) {
      top: 5px;
      transform: rotate(-135deg);
    }
  }

  .audioPlayerList {
    color: $primary_color;
    width: ($player_width)-(2*$player_padding);
    transition: $anim_duration;
    transform: translateX(-200%);
    position: absolute;
    margin-top: $player_padding;
    overflow: auto;
    z-index: 10;
    will-change: transform;

    &.isActive {
      transform: translateX(0);
    }

    .item {
      margin-bottom: 1.5rem;
      border-left: 0.1rem solid transparent;
      transition: 0.2s;

      &:hover {
        padding-left: 0.5rem;
        cursor: pointer;
      }

      .title {
        color: rgba(0, 0, 0, 1);
        font-size: 1rem;
        margin-bottom: 0.75rem;
      }

      .artist {
        color: rgba(0, 0, 0, 0.5);
        font-size: 0.8rem;
      }

      &.isActive {
        border-left-color: black;
        padding-left: 1rem;
      }
    }

    .debugToggle {
      cursor: pointer;
      color: red;
    }
  }

  .audioPlayerUI {
    //margin-top: $player_padding;
    will-change: transform, filter;
    transition: $anim_duration;

    &.isDisabled {
      transform: scale(0.75) translateX(100%);
      filter: blur(5px) grayscale(100%);
    }

    .albumDetails {
      text-align: center;
      margin: 0 0 1rem;

      p {
        margin: 0px;

        &.title {
          font-size: 1rem;
          color: rgba(0, 0, 0, 1);
          text-align: center;
          word-break: break-word;
          max-width: 90%;
          margin: auto;
        }

        &.artist {
          margin-top: 0.5rem;
          font-size: 0.75rem;
          //font-weight: none;
          color: $primary_color;
          transition-delay: 100ms;
        }
      }
    }

    .albumImage {
      width: ($player_width)-($player_padding*2);
      height: ($player_width)-($player_padding*2);
      overflow: hidden;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
        z-index: 10;
        object-fit: cover;
        object-position: 50% 50%;
        border-radius: $player_border_radius;
      }
    }

    .playerButtons {
      position: relative;
      margin: 0 auto;
      //margin-bottom: 1.5rem;
      text-align: center;

      .button {
        font-size: $button_size;
        display: inline-block;
        vertical-align: middle;
        padding: 0.5rem;
        margin: 0 0.25rem;
        color: rgba(0, 0, 0, 0.75);
        border-radius: 50%;

        outline: 0;
        text-decoration: none;
        cursor: pointer;
        transition: $anim_duration;

        &.play {
          font-size: 2*$button_size;
          margin: 0 .5rem;
        }

        &:active {
          opacity: 0.75;
          transform: scale(0.75);
        }

        &.isDisabled {
          color: rgba(0, 0, 0, 0.2);
          cursor: initial;
        }

        &.isDisabled:active {
          transform: none;
        }
      }
    }

    .currentTimeContainer {
      width: 100%;
      height: 1rem;

      display: flex;
      justify-content: space-between;

      .currentTime,
      .totalTime {
        font-size: 0.5rem;
        font-family: monospace;
        color: #656565;
      }
    }

    .currentProgressBar {
      width: 100%;
      background-color: rgba(0, 0, 0, 0.1);
      margin: 0.75rem 0;
      height: 5px;

      .currentProgress {
        background-color: #656565;
        width: 0px;
        height: 5px;
        transition: 100ms;
      }
    }
  }
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
}

/* data change transitions */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $anim_duration;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.bottom_playlist {
  height: 150px;
  margin: 20px -25px 0;
  overflow-x: hidden;
  overflow-y: scroll;

  .item {
    text-align: left;
    font-size: 15px;
    max-width: 90%;
    //word-break: break-all;
    margin-bottom: 5px;
    line-height: 1.2;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    &.isActive {
      font-weight: bold;
      color: #0080DA;
    }
  }
}

.c_button {
  width: 30px;
  height: 30px;
  display: block;
  background-position: center;
  background-size: contain;
}

.previus {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='956.199px' height='956.199px' viewBox='0 0 956.199 956.199' style='enable-background:new 0 0 956.199 956.199;' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M676.786,773.5c17.601,17.6,40.601,26.4,63.601,26.4s46.1-8.801,63.6-26.4c35.101-35.1,35.101-92.1,0-127.301 L633.587,475.6l165.6-165.6c35.1-35.1,35.1-92.1,0-127.3c-35.1-35.1-92.1-35.1-127.3,0L442.587,412 c-35.101,35.1-35.101,92.099,0,127.3L676.786,773.5z'/%3E%3Cpath d='M215.887,956.199c49.7,0,90-40.299,90-90V90c0-49.7-40.3-90-90-90c-49.7,0-90,40.3-90,90v776.199 C125.887,915.9,166.187,956.199,215.887,956.199z'/%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
}

.next {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='956.199px' height='956.199px' viewBox='0 0 956.199 956.199' style='enable-background:new 0 0 956.199 956.199;' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M152.2,773.5c17.6,17.6,40.6,26.4,63.6,26.4s46.1-8.801,63.6-26.4l234.2-234.199C530.5,522.4,540,499.5,540,475.7 c0-23.899-9.5-46.8-26.4-63.6L284.4,182.7c-35.1-35.1-92.1-35.1-127.3,0c-35.1,35.1-35.1,92.1,0,127.3l165.6,165.6L152.2,646.199 C117,681.4,117,738.301,152.2,773.5z'/%3E%3Cpath d='M740.399,956.199c49.7,0,90-40.299,90-90V90c0-49.7-40.3-90-90-90s-90,40.3-90,90v776.199 C650.399,915.9,690.699,956.199,740.399,956.199z'/%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
}

.b_play {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cpath d='M256,0C114.617,0,0,114.615,0,256s114.617,256,256,256s256-114.615,256-256S397.383,0,256,0z M344.48,269.57l-128,80 c-2.59,1.617-5.535,2.43-8.48,2.43c-2.668,0-5.34-0.664-7.758-2.008C195.156,347.172,192,341.82,192,336V176 c0-5.82,3.156-11.172,8.242-13.992c5.086-2.836,11.305-2.664,16.238,0.422l128,80c4.676,2.93,7.52,8.055,7.52,13.57 S349.156,266.641,344.48,269.57z'/%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
}

.b_pause {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 409.6 409.6' style='enable-background:new 0 0 409.6 409.6;' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M204.8,0C91.648,0,0,91.648,0,204.8s91.648,204.8,204.8,204.8s204.8-91.648,204.8-204.8S317.952,0,204.8,0z M182.272,256 c0,12.8-10.24,22.528-22.528,22.528c-12.8,0-22.528-10.24-22.528-22.528V153.6c-0.512-12.288,9.728-22.528,22.016-22.528 c12.8,0,23.04,10.24,23.04,22.528V256z M272.896,256c0,12.8-10.24,22.528-22.528,22.528c-12.8,0-22.528-10.24-22.528-22.528V153.6 c-0.512-12.288,9.728-22.528,22.016-22.528c12.8,0,23.04,10.24,23.04,22.528V256z'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
}

.b_stop {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cpath d='M256,0C114.617,0,0,114.617,0,256s114.617,256,256,256s256-114.617,256-256S397.383,0,256,0z M336,320 c0,8.836-7.156,16-16,16H192c-8.844,0-16-7.164-16-16V192c0-8.836,7.156-16,16-16h128c8.844,0,16,7.164,16,16V320z'/%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
}

</style>